module.exports = __webpack_public_path__ + "static/media/Quicksand-VariableFont_wght.51b6fe99.ttf";